import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@material-ui/core";
 import React, {useState} from "react";
import axios from "axios";
import { api } from "./api/client";

export default function ModalBox(props) {
    const [open, setOpen] = useState(false);
    const [state, setState] = useState({
        ulke: "",
        sehir: "",
        lokasyon_adi:"",
        telefon:"",
        yetkili:"",
        adres:"",
        eposta:""
    });

    const handleChange = name => e => {
        setState({
            ...state,
            [name]: e.target.value
        });
        console.log('state change',state);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <Button variant="contained" size={"small"} color="secondary" onClick={handleClickOpen }>
                +
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Lokasyon Ekle</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    </DialogContentText>

                    <TextField
                        margin="dense"
                        id="ulke"
                        label="Ülke"
                        type="text"
                        onChange={handleChange("ulke")}
                    />
                    <TextField
                        margin="dense"
                        id="sehir"
                        label="Şehir"
                        type="text"
                        onChange={handleChange("sehir")}

                    />
                    <TextField
                        margin="dense"
                        id="lokasyon_adi"
                        label="Lokasyon Adı"
                        type="text"
                        onChange={handleChange("lokasyon_adi")}

                    />
                    <TextField
                        margin="dense"
                        id="telefon"
                        label="Telefon"
                        type="tel"
                        onChange={handleChange("telefon")}

                    />
                    <TextField
                            margin="dense"
                            id="yetkili"
                            label="Yetkili"
                            type="tel"
                            onChange={handleChange("yetkili")}

                    />
                    <TextField
                        margin="dense"
                        id="eposta"
                        label="Eposta"
                        type="email"
                        onChange={handleChange("eposta")}

                    />
                    <TextField
                        margin="dense"
                        id="adres"
                        label="Adres"
                        type="tel"
                        onChange={handleChange("adres")}
                        fullWidth
                        multiline
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button
                        onClick={async () => {
                             await api.post('/lookups/lokasyonlar', {
                                     'ulke': state.ulke,
                                     'sehir': state.sehir,
                                     'lokasyon_adi':state.lokasyon_adi,
                                     'telefon':state.telefon,
                                     'yetkili':state.yetkili,
                                     'adres':state.adres,
                                     'musteri_id':props.musteriID,
                                     'eposta': state.eposta
                            })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.locationChange(true);
                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });
                            setState({open:false});
                        }}
                        color="primary"
                    >
                        Kaydet
                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

